import {
  BASE_URL,
  BIZ_CODE,
  BUSINESS_ID,
  CHANNEL_ID,
} from "@/constants/apiConfig";
import { OAuth2Client, TokenSourceType } from "@gaoding/oauth2-client";
import Cookies from "js-cookie";
import base64 from "./base64";
import { isClient } from "./env";
import { safeParse } from "./safeParse";
import { getAccessTokenFromCookie } from "./server/getAccessTokenFromCookie";
import { tokenFieldName } from "./uid";

type Env = "dev" | "fat" | "stage" | "prod";

const ClientSecretMap = {
  dev: "Xp1jMLO5MvSYkdO9YMwKVucEI5cBLZdC",
  fat: "Xp1jMLO5MvSYkdO9YMwKVucEI5cBLZdC",
};
/**
 * oauth2Client对象，用于获取accessToken登录等相关信息
 * 注意：仅在浏览器端调用，不可在服务端调用
 */
let oauth2Client: OAuth2Client | undefined;

if (typeof window !== "undefined") {
  // OAuth2Client不支持服务端，所以需要在客户端环境下渲染
  oauth2Client = new OAuth2Client({
    env: process.env.NEXT_PUBLIC_DEPLOY_ENV as Env,
    clientId: "huaban",
    clientSecret: ClientSecretMap[process.env.NEXT_PUBLIC_DEPLOY_ENV],
    portal: "huaban",
    bizCode: BIZ_CODE,
    businessId: BUSINESS_ID,
    channelId: CHANNEL_ID,
    webRequireURI: BASE_URL,
    tokenSourceType: TokenSourceType.LocalStorage,
  });
}

export default oauth2Client;

export async function getAccessToken(cookie?: string) {
  if (isClient()) {
    return oauth2Client?.getAccessToken();
  } else {
    // 服务端
    if (cookie) {
      return getAccessTokenFromCookie(cookie);
    }
  }
}

export function parseTokenPayload(token: string) {
  const info = token.split(".")[1];
  return safeParse(base64.decode(info)) as {
    iss: "ums";
    sub: number;
    aud: "huaban";
    exp: number;
    ucid: string;
    jti: string;
    hb_id: string;
  };
}

/**当前登录用户是否是一体化用户 */
export function isUnifiedUser(token?: string) {
  let accessToken = token;
  if (!token) {
    const tokenValue = Cookies.get(tokenFieldName);

    if (tokenValue) {
      accessToken = safeParse(base64.decode(tokenValue))?.access_token;
    } else {
      return false;
    }
  }

  // 有 token 就认为是一体化用户
  return true;
}
